import React from "react";
import { Container } from "react-bootstrap";

const BirdCam = () => (
  <section id="bird-cam" className="py-5 bg-light text-center">
    <Container>
      <i className="fas fa-video fa-3x text-primary mb-3"></i>
      <h2 className="fw-bold">Bird CAM: Coming Soon!</h2>
      <p className="lead text-muted">
        We're working hard to bring you a live feed from our aviary.
      </p>
      <div className="construction-banner">
        <i className="fas fa-hard-hat me-2"></i>Under Construction
      </div>
    </Container>
  </section>
);
export default BirdCam;
